import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import {
  CarouselSection,
  CarouselHeader,
  CarouselTitle,
  CarouselSubtitle,
  CarouselWrapper,
  NavigationButtons,
  NavButtonPrev,
  NavButtonNext,
  NavIcon,
  EmptyState,
  EmptyStateText,
} from "./styles";
import DisputeCard from "./DisputeCard";
import { DisputesCarouselProps } from "./types";
import { SWIPER_CONFIG, CAROUSEL_TEXTS } from "./constants";

const DisputesCarousel: React.FC<DisputesCarouselProps> = ({
  disputes,
  onOpen,
  setSelectedDispute,
}) => {
  return (
    <CarouselSection>
      <CarouselHeader>
        <CarouselTitle level={4}>{CAROUSEL_TEXTS.title}</CarouselTitle>
        <CarouselSubtitle>{CAROUSEL_TEXTS.subtitle}</CarouselSubtitle>
      </CarouselHeader>

      <CarouselWrapper>
        {disputes && Array.isArray(disputes) && disputes.length > 0 ? (
          <>
            <Swiper
              modules={[Navigation, Pagination]}
              {...SWIPER_CONFIG}
            >
              {disputes.map((dispute) => (
                <SwiperSlide key={dispute.id}>
                  <DisputeCard
                    dispute={dispute}
                    onOpen={onOpen}
                    setSelectedDispute={setSelectedDispute}
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            <NavigationButtons>
              <NavButtonPrev className="swiper-button-prev">
                <NavIcon>
                  <FontAwesomeIcon icon={faArrowLeft} />
                </NavIcon>
              </NavButtonPrev>
              <NavButtonNext className="swiper-button-next">
                <NavIcon>
                  <FontAwesomeIcon icon={faArrowRight} />
                </NavIcon>
              </NavButtonNext>
            </NavigationButtons>
          </>
        ) : (
          <EmptyState>
            <EmptyStateText>{CAROUSEL_TEXTS.emptyState}</EmptyStateText>
          </EmptyState>
        )}
      </CarouselWrapper>
    </CarouselSection>
  );
};

export default DisputesCarousel;
